import { Box, Typography } from "@mui/material";
import {  EventBusy, EventAvailable, CalendarToday, FindInPage } from "@mui/icons-material";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ReceiptSharpIcon from '@mui/icons-material/ReceiptSharp';
import SummarizeSharpIcon from '@mui/icons-material/SummarizeSharp';
import GppGoodIcon from '@mui/icons-material/GppGood';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruckFast } from "@fortawesome/free-solid-svg-icons";
import ListAltIcon from '@mui/icons-material/ListAlt';
import ShieldIcon from '@mui/icons-material/Shield';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ArchiveIcon from '@mui/icons-material/Archive';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import SvgIcon from '@mui/material/SvgIcon';
import { xlCol, xlColq } from "../../common/constants";
import { GUJRAT_COMPANY_ID, STA_COMPANY_ID } from "../../../helper/companyIdhardcode";

const RedCircle = ({number}) => (
    <Box
      sx={{
        width: 24,
        height: 24,
        borderRadius: '50%',
        backgroundColor: '#ed4348',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0'
      }}
    >
      <Typography variant="body2" fontWeight="bold" color="#fff">
        {number}
      </Typography>
    </Box>  
  );
  const ShieldWithHeartIcon = () => {
  return (
    <Box sx={{ position: 'relative', width: 24, height: 24 }}>
      {/* Base Shield Icon */}
      <ShieldIcon
        sx={{
          fontSize: 32,
          color: '#5F6368', // optional styling
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      />
      {/* Heart Icon layered inside */}
      <FavoriteIcon
        sx={{
          fontSize: 16,
          color: '#FFFFFF',
          position: 'absolute',
          top: 8,
          left: 8,
        }}
      />
    </Box>
  );
};

const ArchiveWithBookmarkIcon = () => {
  return (
    <Box sx={{ position: 'relative', width: 32, height: 32 }}>
      {/* Base Archive Icon */}
      <ArchiveIcon
        sx={{
          fontSize: 32,
          color: '#5F6368', // brownish archive color
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      />

      {/* Box to hide arrow inside ArchiveIcon */}
      <Box
        sx={{
          width: 14,
          height: 6,
          backgroundColor: '#5F6368',
          position: 'absolute',
          top: 16,
          left: 10.5,
        }}
      />

      {/* Bookmark Icon */}
      <BookmarkIcon
        sx={{
          fontSize: 18,
          color: '#fff', // white or contrast color
          backgroundColor: '#5F6368',
          borderRadius: '4px',
          padding: '2px',
          position: 'absolute',
          top: 8,
          left: 7,
        }}
      />
    </Box>
  );
};


function BoxWithLinesIcon(props) {
  return (
     <SvgIcon {...props}>
      {/* Main rectangle */}
      <rect x="2" y="2" width="20" height="20" rx="2" ry="2" fill="#5F6368" />

      {/* Horizontal white lines */}
      <line x1="6" y1="8" x2="18" y2="8" stroke="white" strokeWidth="2" />
      <line x1="6" y1="12" x2="18" y2="12" stroke="white" strokeWidth="2" />
      <line x1="6" y1="16" x2="18" y2="16" stroke="white" strokeWidth="2" />

       {/* Larger circle in bottom-right corner */}
      <circle cx="19" cy="19" r="6" fill="#5F6368" stroke="white" strokeWidth="2" />

      {/* Three horizontal white dots inside the circle */}
      <circle cx="16.8" cy="19" r="0.6" fill="white" />
      <circle cx="19" cy="19" r="0.6" fill="white" />
      <circle cx="21.2" cy="19" r="0.6" fill="white" />
    </SvgIcon>
  );
}
export const getStatusOverview = (db = {}, cs = {}) => [
    { label: db.bookedLrs || 'Booked LRs', key: 'TotalBookingNetAmt', type: 'info', icon: <CalendarToday sx={{ fontSize: 24, color: '#2c679d' }} />, handleClick:'handleBookedLrs' },
    { label: db.pendingLrs || 'Pending LRs', key: 'PendingLRs', type: 'error', icon: <EventBusy sx={{ fontSize: 24, color: '#ed4348' }} /> },
    { label: db.deliveredLrs || 'Delivered LRs', key: 'TotalDeliveryNetAmount', type: 'success', icon: <EventAvailable sx={{ fontSize: 24, color: '#398d5d' }} /> },
    { label: db.pendingDispatchLrs || 'Pending Dispatch LRs', key: 'PendingDispatchLRs', type: 'error', icon: <EventBusy sx={{ fontSize: 24, color: '#ed4348' }} /> },
    { label: db.pendingReceiveLrs || 'Pending Receive LRs', key: 'PendingReceiveLRs', type: 'error', icon: <EventBusy sx={{ fontSize: 24, color: '#ed4348' }} /> },
    { label: db.pendingDeliveryLrs || 'Pending Delivery LRs', key: 'PendingDeliveryLRs', type: 'error', icon: <EventBusy sx={{ fontSize: 24, color: '#ed4348' }} /> },
    { label: db.sevenDaysPendingLrs || '7 Days Pending LRs', key: 'SevenDaysPendingLrs', type: 'error', icon: <RedCircle number={7} /> },
    { label: db.thirtyDaysPendingLrs || '30 Days Pending LRs', key: 'ThirtyDaysPendingLrs', type: 'error', icon: <RedCircle number={30} /> },
    { label: db.missingLrs || "Missing LR's", key: 'TotalBookingLost', type: 'error', icon: <FindInPage sx={{ fontSize: 24, color: '#ed4348' }} /> }
]
export const getBookingOverview = (db = {}, cs = {}) => [
    { label: db.freightCharges || 'Freight Charges', key: 'TotalBookingFreight', icon: <ArchiveWithBookmarkIcon  /> },
    { label: db.documentCharges || 'Document Charges', key: 'TotalBookingDocChg', icon: <SummarizeSharpIcon style={{ fontSize: 24 }} /> },
    { label: cs.GST || 'GST', key: 'TotalBookingGST', icon: <ReceiptSharpIcon style={{ fontSize: '24px' }}/> },
    { label: db.insurance || 'Insurance', key: 'TotalBookingInsurance', icon: <ShieldWithHeartIcon /> },
    { label: db.otherCharges || 'Other Charges', key: 'TotalBookingOtherChg', icon: <BoxWithLinesIcon style={{ fontSize: 24 }} /> },
    { label: db.totalAmount || 'Total Amount', key: 'TotalBookingNetAmt', icon: <ListAltIcon style={{ fontSize: 24 }} /> },
]
export const getDeliveryOverview = (db = {}) => [
    { label: db.freightCharges || 'Freight Charges', key: 'TotalDeliveryFreight', icon: <ArchiveWithBookmarkIcon  /> },
    { label: db.deliveryCharges || 'Delivery Charges', key: 'TotalDeliveryHomeDeliveryChg', icon: <FontAwesomeIcon icon={faTruckFast} style={{ fontSize: 24 }} /> },
    { label: db.totalAmount || 'Total Amount', key: 'TotalDeliveryNetAmount', icon: <ListAltIcon style={{ fontSize: 24 }} /> },
]
export const getBranchMonthlyBooking = (db = {}, cs = {}) => [
  { headerName: db.sn || 'SN', key: 'rank' },
  { headerName: db.branchName || 'Branch Name', key: 'BranchName' },
  { headerName: cs.month || 'Month', key: 'MONTHNAME' },
  { headerName: db.targetAmount || 'Target Amount', key: 'TargetAmount', align: 'right' },
  { headerName: db.targetAsOnToday || 'Target As on Today', key: 'TillTodayTarget', align: 'right' },
  { headerName: db.achievement || 'Achievement', key: 'Acheived', align: 'right' },
  { headerName: db.achievementInPercent || 'Achievement in %', key: 'AchievementPercentage', align: 'right' }
];
export const getMonthlyTargetHeader = (db = {}, companyId) => {
  const headers = [
    { header: db.sn || 'SN', exportHead: db.sn || 'SN', field: 'rank', xlCol,weight:1, isSortIcon: false },
    { header: db.branchName || 'Branch Name', exportHead: db.branchName || 'Branch Name', field: 'BranchName', xlCol,weight:2, isSortIcon: true },
    { header: db.type || 'Type', exportHead: db.type || 'Type', field: 'CompanyType', xlCol,weight:1, isSortIcon: true },
    { header: db.targetAmount || 'Target Amount', exportHead: db.targetAmount || 'Target Amount', field: 'TargetAmount', align: 'right', xlCol: xlColq,weight:1, isSortIcon: true },
    { header: db.targetAsOnToday || 'Target As on Today', exportHead: db.targetAsOnToday || 'Target As on Today', field: 'TillTodayTarget', align: 'right', xlCol: xlColq,weight:1, isSortIcon: true },
    { header: db.achievement || 'Achievement', exportHead: db.achievement || 'Achievement', field: 'Acheived', align: 'right', xlCol: xlColq,weight:1, isSortIcon: true },
    { header: db.achievementInPercent || 'Achievement in %', exportHead: db.achievementInPercent || 'Achievement in %', field: 'AchievementPercentage', align: 'right', xlCol: xlColq,weight:1, isSortIcon: true }
  ];
  if ([GUJRAT_COMPANY_ID, STA_COMPANY_ID].includes(companyId)) {
    headers.push(
      { header: db.targetRemaining || 'Target Remaining', exportHead: db.targetRemaining || 'Target Remaining', field: 'TargetRemain', align: 'right', xlCol: xlColq, weight: 1, isSortIcon: true },
      { header: db.perDayAverage || 'PerDay Average', exportHead: db.perDayAverage || 'PerDay Average', field: 'PerDayAvg', align: 'right', xlCol: xlColq, weight: 1, isSortIcon: true },
      { header: db.percentRemaining || '% Remaining', exportHead: db.percentRemaining || '% Remaining', field: 'RemainingPercentage', align: 'right', xlCol: xlColq, weight: 1, isSortIcon: true }
    );
  }
  return headers;
};
export const getPartyMonthlyBooking = (db = {}) => [
  { headerName: db.sn || 'SN', key: 'rank' },
  { headerName: db.partyName || 'Party Name', key: 'name' },
  { headerName: db.businessLrs || 'Business (LRs)', key: 'business', align: 'right' }
];
export const getDeliveredLrTable = (db = {}, cs = {}) => [
  { headerName: cs.paymentType || 'Payment Type', key: 'PaymentType' },
  { headerName: db.lrCount || 'LR Count', key: 'LRCount', align: 'right' },
]

export const statusOverview = getStatusOverview()
export const bookingOverview = getBookingOverview()
export const deliveryOverview = getDeliveryOverview()
export const branchMonthlyBooking = getBranchMonthlyBooking()
export const monthlyTargetHeader = getMonthlyTargetHeader()
export const partyMonthlyBooking = getPartyMonthlyBooking()
export const deliveredLrTable = getDeliveredLrTable()

export const bookedLRs = `http://buscrs.com/ReportCargo/BookingSummaryReport?`
export const bookedLRParams = {
FromDate:0,
ToDate:0,
intBranchID:0
}

export const pendingLRs =`http://buscrs.com/ReportCargo/GetCargoNonMovedDetailsWeb?`
export const commonPendingLRParams = {
  FromDate:0,
  ToDate:0,
  intCompanyId:0,
  intBranchId:0,
  intUserID:0,
  intTimeNotMovedSince:0,
  AllowViewAllReport:1,
  IncludeDate:0,
  StatusCode:'',
  Status:'',
  SelectBranchName:'',
  intIsDays:1,
  intDaysOrHours:0,
  IsSummary:1,
  IsBranchSummary:1,
  FinYrID:0,
  IsTranDtWise:0,
  IsOnlyExpressParcel:2,
  ver:4
}

//Booking overview parameters

export const commonBkngDelOverviewUrl =`http://buscrs.com/ReportCargo/DailyBranchwiseCollectionReport2?`
export const commonBkngDelOverviewParams = {
  FromDate: 0,
  ToDate: 0,
  BranchId: 0,
  Summary: 1,
  BranchName: ''
}
export const getAnalysisHeaders = (db = {}) => [
  { name: db.sn || 'SN', field: 'sn', headerSx: {} },
  { name: db.partyNameUpper || 'PARTY NAME', field: 'partyName', headerSx: {} },
]
export const getBranchHeaders = (db = {}) => [
  { name: db.sn || 'SN', field: 'sn', headerSx: {} },
  { name: db.branchNameUpper || 'BRANCH NAME', field: 'branchName', headerSx: {} },
]
export const getUserHeaders = (db = {}) => [
  { name: db.sn || 'SN', field: 'sn', headerSx: {} },
  { name: db.userNameUpper || 'USER NAME', field: 'UserName', headerSx: {} },
  { name: db.branchNameUpper || 'BRANCH NAME', field: 'branchName', headerSx: {} },
]
export const getOverAllHeaders = (db = {}) => [
  { name: db.sn || 'SN', field: 'sn', headerSx: {} },
  { name: db.senderNameUpper || 'SENDER NAME', field: 'SenderName', headerSx: {} },
  { name: db.branchNameUpper || 'BRANCH NAME', field: 'branchName', headerSx: {} },
]
export const getTotalHeaders = (db = {}) => [{ name: db.totalUpper || 'TOTAL', field: 'total',xlCol: xlColq, headerSx: {} }]
export const getRangeList = (db = {}) => [
  { name: db.months3 || '3 Months', value: 3 },
  { name: db.months6 || '6 Months', value: 6 },
  { name: db.months9 || '9 Months', value: 9 },
  { name: db.year1 || '1 Year', value: 12 },
]
export const getViewTypeList = (db = {}) => [
  { name: db.partyWise || 'Party Wise', id: 1 },
  { name: db.partyCityWise || 'Party City Wise', id: 2 },
  { name: db.partyBranchWise || 'Party Branch Wise', id: 3 },
]
export const getBranchViewTypeList = (db = {}) => [
  { name: db.branchWiseUpper || 'BRANCH WISE', id: 1 },
  { name: db.cityBranchWiseUpper || 'CITY - BRANCH WISE', id: 2 },
]
export const getUserViewTypeList = (db = {}) => [
  { name: db.userwiseWiseUpper || 'USERWISE WISE', id: 1 },
  { name: db.branchWiseUpper || 'BRANCH WISE', id: 2 },
]
export const getTransTypeList = (db = {}, cs = {}) => [
  { name: cs.booking || 'Booking', value: 'B' },
  { name: cs.delivery || 'Delivery', value: 'D' },
]
export const getOrderList = (db = {}) => [
  { name: db.ascending || 'Ascending', id: 1 },
  { name: db.descending || 'Descending', id: 2 },
]
export const getTotalAmountGreaterThan = (db = {}) => [
  { name: db.allTitleCase || 'All', id: 0 },
  { name: db.greaterThan100 || '>100', id: 100 },
  { name: db.greaterThan250 || '>250', id: 250 },
  { name: db.greaterThan500 || '>500', id: 500 },
  { name: db.greaterThan750 || '>750', id: 750 },
  { name: db.greaterThan1000 || '>1000', id: 1000 },
]

export const analysisHeaders = getAnalysisHeaders()
export const branchHeaders = getBranchHeaders()
export const userHeaders = getUserHeaders()
export const overAllHeaders = getOverAllHeaders()
export const totalHeaders = getTotalHeaders()
export const rangeList = getRangeList()
export const viewTypeList = getViewTypeList()
export const transTypeList = getTransTypeList()
export const orderList = getOrderList()
export const totalAmountGreaterThan = getTotalAmountGreaterThan()
